export default __webpack_public_path__ + "static/media/eternity.f4204934.png";